import React from 'react';
import classNames from 'classnames/bind';
import { GroupByVisitArea } from '@/components/CustomTravel/CustomInit';
import styles from './SelectLocationForm.module.scss';

const cx = classNames.bind(styles);
export const VisitAreas = ({ visitAreas }: { visitAreas: GroupByVisitArea[] }) => {
  return (
    <div className={cx('VisitAreas')}>
      <div className={cx('areas')}>
        {visitAreas.map((area) => (
          <div className={cx('area')} key={area.countryCode}>
            <span className={cx('step')}>{area.countryName}</span>
            <span className={cx('step')}>
              {area.cities.map((city) => (
                <div className={cx('city')} key={city.cityCode}>
                  {city.cityName}
                </div>
              ))}
            </span>
          </div>
        ))}
        지역을 방문하는 상품을 선택하셨어요.
      </div>
      {visitAreas?.length > 2 && (
        <p className={cx('description')}>
          여행지 변경을 원하시나요?
          <br />
          여러 국가가 포함된 상품에서는 여행사 상담을 통해 자세한 여행코스를 정할 수 있어요.
        </p>
      )}
    </div>
  );
};
